import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';

const CATEGORY_FILTERS = [{ v: '', l: 'Todas' }, { v: 'pequeno-almoco', l: 'Peq.-alm.' }, { v: 'almoco', l: 'Almoço' }, { v: 'jantar', l: 'Jantar' }, { v: 'lanche', l: 'Lanche' }, { v: 'ceia', l: 'Ceia' }];
const TAG_FILTERS = ['carne', 'peixe', 'ovo', 'vegetariano', 'leguminosas', 'rápido', 'infantil', 'pós-parto', 'gravidez', 'batch cooking', 'família'];

/** Modal reutilizável de seleção de receita (Ementa Semanal cliente + Ementa Fixa admin). */
export default function RecipePickerDialog({ open, onClose, recipes, onSelect, title }) {
  const [search, setSearch] = useState('');
  const [cat, setCat] = useState('');
  const [tag, setTag] = useState('');

  const filtered = recipes.filter(r => {
    if (search && !r.name.toLowerCase().includes(search.toLowerCase())) return false;
    if (cat && r.category !== cat) return false;
    if (tag && !(r.tags || []).includes(tag)) return false;
    return true;
  });

  const handleClose = () => { setSearch(''); setCat(''); setTag(''); onClose(); };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleClose(); }}>
      <DialogContent className="rounded-3xl border-brand-border max-h-[80vh] overflow-hidden flex flex-col" data-testid="recipe-picker-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-brand-text">Escolher receita{title ? ` - ${title}` : ''}</DialogTitle>
        </DialogHeader>
        <Input
          placeholder="Procurar receita..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="rounded-2xl border-brand-border mb-2"
          data-testid="recipe-search-input"
        />
        <div className="flex gap-1.5 mb-2 overflow-x-auto pb-1">
          {CATEGORY_FILTERS.map(c => (
            <button key={c.v} onClick={() => setCat(cat === c.v ? '' : c.v)} className={`px-2 py-1 rounded-full text-[10px] whitespace-nowrap transition-all ${cat === c.v ? 'bg-brand-green text-white' : 'bg-brand-bg text-brand-muted'}`} data-testid={`recipe-cat-${c.v || 'todas'}`}>{c.l}</button>
          ))}
        </div>
        <div className="flex gap-1 mb-2 overflow-x-auto pb-1">
          {TAG_FILTERS.map(t => (
            <button key={t} onClick={() => setTag(tag === t ? '' : t)} className={`px-2 py-0.5 rounded-full text-[9px] whitespace-nowrap ${tag === t ? 'bg-brand-gold/20 text-brand-gold-hover' : 'bg-brand-bg/50 text-brand-placeholder'}`} data-testid={`recipe-tag-${t}`}>{t}</button>
          ))}
        </div>
        <div className="overflow-y-auto flex-1 space-y-2 max-h-[50vh]">
          {filtered.length === 0 ? (
            <p className="text-center text-brand-muted py-8 text-sm" data-testid="recipe-picker-empty">Sem receitas. Adiciona receitas primeiro.</p>
          ) : (
            filtered.map(recipe => (
              <button
                key={recipe.id}
                onClick={() => { onSelect(recipe.id); handleClose(); }}
                className="w-full text-left p-3 rounded-2xl hover:bg-brand-mint/10 border border-transparent hover:border-brand-mint/30 transition-all"
                data-testid={`select-recipe-${recipe.id}`}
              >
                <div className="flex items-center gap-2">
                  <p className="font-medium text-sm text-brand-text">{recipe.name}</p>
                  {recipe.is_public && <span className="text-[9px] bg-brand-gold/15 text-brand-gold-hover px-1.5 py-0.5 rounded-full">Base</span>}
                </div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-brand-muted">{recipe.ingredients?.length || 0} ingredientes</span>
                  {recipe.category && <span className="text-[9px] bg-brand-mint/15 text-brand-green px-1.5 py-0.5 rounded-full">{recipe.category}</span>}
                </div>
              </button>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
